module.exports = __webpack_public_path__ + "static/media/Services - Clinical Trials-graphic.4d72b2c2.svg";